import { SvgIcon, SvgIconProps } from "@mui/material";

export const SortingDownArrowIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <rect
        width="20"
        height="20"
        x="20"
        fill="#E7E9FE"
        rx="10"
        transform="rotate(90 20 0)"
      />
      <path
        stroke="#5563F5"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M10 15.833V4.167m-4.167 7.5L10 15.833m4.167-4.166L10 15.833"
      />
    </svg>
  </SvgIcon>
);
